module.exports = __webpack_public_path__ + "img/box_3.3ec8245e.png";